import React from "react";
import bgImg from "../../Assets/About/bg-about.png";
import { MdWorkHistory } from "react-icons/md";
import { FaBuilding, FaUserTie, FaGlobe } from "react-icons/fa";
import { GiTeacher } from "react-icons/gi";

const AboutICVCertification = () => {
  const stats = [
    {
      id: 1,
      icon: (
        <MdWorkHistory className="text-[#46B9EA] w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 lg:w-16 lg:h-16" />
      ),
      number: "10+",
      label: "Years of Expertise",
    },
    {
      id: 2,
      icon: (
        <FaBuilding className="text-[#46B9EA] w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 lg:w-16 lg:h-16" />
      ),
      number: "500+",
      label: "Company Certified",
    },
    {
      id: 3,
      icon: (
        <FaUserTie className="text-[#46B9EA] w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 lg:w-16 lg:h-16" />
      ),
      number: "50+",
      label: "Experienced Auditors",
    },
    {
      id: 4,
      icon: (
        <GiTeacher className="text-[#46B9EA] w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 lg:w-16 lg:h-16" />
      ),
      number: "200+",
      label: "Consultants",
    },
    {
      id: 5,
      icon: (
        <FaGlobe className="text-[#46B9EA] w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 lg:w-16 lg:h-16" />
      ),
      number: "30+",
      label: "Worldwide Certifications",
    },
  ];

  return (
    <div className="w-full relative bg-[#0D2F44] mt-10">
      {/* Background image */}
      <img
        src={bgImg}
        alt="About Background"
        className="w-full h-[320px] md:h-[380px] object-cover"
      />

      {/* Overlay with stats */}
      <div className="absolute inset-0 grid place-items-center bg-black bg-opacity-40">
        <div className="container px-4 mx-auto">
          <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-5 gap-6 sm:gap-8 lg:gap-10">
            {stats.map((item) => (
              <div
                key={item.id}
                className="grid justify-items-center text-center p-2 sm:p-4"
              >
                {item.icon}
                <span className="mt-2 text-white text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold">
                  {item.number}
                </span>
                <span className="text-xs sm:text-sm md:text-base lg:text-lg text-white mt-1 sm:mt-2">
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutICVCertification;
